import React, { useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  inputGrid: {
    maxWidth: '40rem'
  },
  saveButton: {
    marginRight: '16px',
    marginBottom: '12px'
  }
}));

const AddListModal = props => {
  const { isOpen, closeCreateListModal, lists } = props;
  const {
    updateCurrentErrorValidationSegment,
    shouldShowError,
    getErrorMessage,
    thisList,
    setListName,
    onBlur,
    onClickSaveListName
  } = lists;
  const classes = useStyles();

  useEffect(() => {
    updateCurrentErrorValidationSegment('createList');
  }, []);

  const handleListNameChange = event => {
    setListName(event.target.value);
  };

  return (
    <Dialog
      open={isOpen}
      aria-labelledby="form-dialog-title"
      fullWidth
      maxWidth="sm">
      <Typography variant="h2">
        <DialogTitle id="form-dialog-title" disableTypography={true}>
          Create List
        </DialogTitle>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={closeCreateListModal}>
          <Close />
        </IconButton>
      </Typography>
      <DialogContent>
        <TextField
          className={classes.inputGrid}
          fullWidth
          label="List Name"
          margin="dense"
          name="name"
          variant="outlined"
          required
          value={thisList.listName || ''}
          onChange={handleListNameChange}
          onBlur={onBlur}
          error={shouldShowError('listName')}
          helperText={getErrorMessage('listName')}
        />
      </DialogContent>
      <DialogActions>
        <Button
          className={classes.saveButton}
          color="primary"
          variant="contained"
          onClick={onClickSaveListName}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddListModal;
